/* eslint-disable @typescript-eslint/no-empty-function */
import Button from '@/components/Button/Button';
import { useSTKContext } from '@/context/context';
import { usePriceDeviations } from '@/services/menu/menus.service';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { X } from 'react-feather';
import styles from './PriceDeviationsDrawer.module.css';
import { PriceDeviationsDrawerProps } from './PriceDeviationsDrawerProps.types';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ButtonVariants } from '@/components/Button/Button.types';
import { PriceDeviationsTable } from './PriceDeviationsTable';

export const PriceDeviationsDrawer: FC<PriceDeviationsDrawerProps> = ({
  isOpen,
  onClose,
  variantIds,
  selectedGroupName,
  cameFromEditDrawer,
}) => {
  const { storesAndGroups } = useSTKContext();
  let selectedStores;
  // grabbing selectedStores from the context
  if (storesAndGroups.origin === 'tab-stores-groups') {
    selectedStores = storesAndGroups.storeGroups?.find((item) => item.storeGroup === selectedGroupName)?.stores || [];
  } else {
    selectedStores =
      storesAndGroups.stores?.filter((item) => item.storeGroup === selectedGroupName).map((item) => item.storeNo) || [];
  }

  const { t } = useTranslation();

  const { data: priceDeviations = [], isLoading: isPriceDeviationsLoading } = usePriceDeviations(
    true,
    selectedStores,
    variantIds,
  );

  return (
    <div>
      <SwipeableDrawer open={isOpen} onClose={onClose} onOpen={() => {}} anchor="bottom">
        <div className={styles.container}>
          <header>
            <div>
              <h1>{t('priceDeviations.priceDeviations')}</h1>
            </div>
            <button type="button" onClick={onClose}>
              <X data-testid="x-icon" size={24} color="var(--black-900)" />
            </button>
          </header>
          <div className={styles.content}>
            {cameFromEditDrawer && (
              <Button
                variant={ButtonVariants.Text}
                className={styles.backLink}
                onClick={onClose}
                data-testid="backToEdit"
              >
                <ArrowBackIcon fontSize="large" />
                <div>{t('priceDeviations.backToEdit')}</div>
              </Button>
            )}
            <div className={styles.selectedGroupName}>{selectedGroupName}</div>
            <PriceDeviationsTable data={priceDeviations} />
          </div>
        </div>
      </SwipeableDrawer>
    </div>
  );
};
